export default __webpack_public_path__ + "static/media/aging@2x.acea4e51.png";